import {
  StoreAction,
  GetStoreListType,
  StoreActionTypes,
  GetStoreDetailType,
  PutStoreTapPayCardType,
  PutStorePlanType,
  PostSearchPaymentHistoryType,
  DeleteStorePlanType,
  PostSearchPointHistoryType,
  StoreSMSDetail,
} from "./storeTypes";

export const getStoreListAction = (list: GetStoreListType): StoreAction => ({
  type: StoreActionTypes.GET_STORE_LIST,
  payload: list,
});

export const getStoreDetailAction = (
  store: GetStoreDetailType
): StoreAction => ({
  type: StoreActionTypes.GET_STORE_DETAIL,
  payload: store,
});

export const getAllStoreSMSStatusDetailAction = (
  smsList: StoreSMSDetail[]
): StoreAction => ({
  type: StoreActionTypes.GET_ALL_STORE_SMS_STATUS_DETAIL,
  payload: smsList,
});

export const getStoreSMSStatusDetailAction = (
  sms: StoreSMSDetail
): StoreAction => ({
  type: StoreActionTypes.GET_STORE_SMS_STATUS_DETAIL,
  payload: sms,
});

export const putStoreTapPayCardAction = (
  store: PutStoreTapPayCardType
): StoreAction => ({
  type: StoreActionTypes.PUT_STORE_TAP_PAY_CARD,
  payload: store,
});

export const putStorePlanAction = (store: PutStorePlanType): StoreAction => ({
  type: StoreActionTypes.PUT_STORE_PLAN,
  payload: store,
});

export const postSearchPaymentHistoryAction = (
  log: PostSearchPaymentHistoryType
): StoreAction => ({
  type: StoreActionTypes.POST_SEARCH_PAYMENT_HISTORY,
  payload: log,
});

export const postSearchPointHistoryAction = (
  log: PostSearchPointHistoryType
): StoreAction => ({
  type: StoreActionTypes.POST_SEARCH_POINT_HISTORY,
  payload: log,
});

export const deleteStorePlanAction = (
  store: DeleteStorePlanType
): StoreAction => ({
  type: StoreActionTypes.DELETE_STORE_PLAN,
  payload: store,
});
